import $ from 'jquery';
import Shuffle from "shufflejs"
import btmq from './Plugins/BootstrapMediaQuery';
import ifExists from './Plugins/ifExists';

import GlobalFormPopup from "./classes/GlobalFormPopup"
import VimeoEmbed from "./classes/VimeoEmbed"
import VideoModal from "./classes/VimeoModal"
import ImageModal from "./classes/ImageModal"
import QuantityInput from "./classes/QuantityInput"
import MaterialInput from "./classes/MaterialInput"
import ProductImageGallery from "./classes/ProductImageGallery";
import PopUp from "./classes/PopUp";

//Remove no-js class
document.documentElement.className = document.documentElement.className.replace("no-js", "js");

const AUTOFILLED = 'is-autofilled'
const onAutoFillStart = (el) => el.classList.add(AUTOFILLED)
const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED)
const onAnimationStart = ({target, animationName}) => {
    switch (animationName) {
        case 'onAutoFillStart':
            return onAutoFillStart(target)
        case 'onAutoFillCancel':
            return onAutoFillCancel(target)
    }
}

document.querySelector('input').addEventListener('animationstart', onAnimationStart, false);

$(function () {
    // Document ready

    // scroll to faq item and open when matched hashtag in url
    if (window.location.hash) {
        //get height of header element
        let headerHeight = $('#header').outerHeight();

        // check if there is an element on the page with classname faq-block
        if ($('.faq-block').length) {
            let hash = window.location.hash.substring(1);

            $('.faq-block').each(function (elem) {
                let faqItem = $(this)
                let faqItemButton = $(this).find('.faq-button')
                let faqItemAnchorID = faqItem.attr('id')

                if (faqItemAnchorID === hash) {
                    // scroll to item
                    let faqItemOffset = faqItem.offset().top;
                    $('html, body').animate({
                        scrollTop: faqItemOffset - headerHeight - 32
                    }, 1000);


                    setTimeout(function () {
                        faqItem.find('.collapse').collapse();
                    }, 1000);
                }
            })
        }
    }

    //handle gravityforms hidden fields
    jQuery("#input_19_17").change(function () {
        var cur_text = jQuery('option:selected', this).text();
        jQuery('input#input_19_27').val(cur_text);
    });
    // product
    jQuery("#input_19_5").change(function () {
        var product_text = jQuery('option:selected', this).text();
        jQuery('input#input_19_28').val(product_text);
    });

    //initializeFloatingLabels();

    //init tooltips
    $('[data-toggle="radio-img-tooltip"]').tooltip()

    //disable country fields default value in checkout
    const $countryFields = [document.getElementById('billing_country'), document.getElementById('shipping_country')]
    if ($countryFields && $countryFields.length > 0) {
        $countryFields.forEach($countryField => {
            if ($countryField && $countryField.tagName.toLowerCase() === 'select') {
                Array.from($countryField.options).forEach((option) => {
                    if (option.value === '') option.disabled = true
                })
            }
        })
    }

    const handleFloatLabels = () => {
        $('.gform_wrapper').find('.has-float-label').addClass('float-container');
        $('.woocommerce-account').find('.woocommerce-form-row').addClass('float-container');
        $('.woocommerce-checkout .woocommerce-form-login').find('.form-row').addClass('float-container');

        const floatContainers = $('.float-container');

        floatContainers.each((i, element) => {
            const $element = $(element);
            let $input = $element.find('input');
            if ($input.length === 0) $input = $element.find('textarea');

            if ($input.val() || $input.hasClass('.is-autofilled')) {
                $element.addClass('active');
            } else {
                $element.removeClass('active');
            }

            $input.removeAttr('placeholder');

            $input.on('focus', (e) => {
                $element.addClass('active');
            }).on('blur', (e) => {
                if (!$input.val()) {
                    $element.removeClass('active');
                }
            });
        });
    }

    jQuery('body').on('wpo_wcnlpc_fields_updated', () => {
        handleFloatLabels()
    })

    jQuery(document).on('gform_post_render', () => {
        handleFloatLabels()
    })

    jQuery('#billing_country').on('change', () => {
        handleFloatLabels()
    })

    $(document).on('click', '.searchtoggle', function () {
        $('.search-bar-mob input').focus();
    });

    //init floating labels
    handleFloatLabels();

    /**
     * no scroll after open menu
     */
    $.ifExists(".navbar-toggler", function (hamburger) {
        hamburger.on("click", function (e) {
            e.preventDefault();

            $('.overlay').toggle();

            if ($('.navbar-collapse .show')) {
                $('body').toggleClass('noScroll');
            }
        });
    });

    /**
     * Sticky header product
     */
    // Hide the sticky header for bundle products
    if ($('.product.type-product').hasClass('product-type-bundle')) {
        $('#product-sticky-header').hide();
    } else {
        // Existing code for non-bundle products
        var aa = $('#product-sticky-header');
        var bb = $('.composite_form');

        $.ifExists(bb, function () {
            aa.remove();
        });

        $.ifExists(aa, function (iteml) {
            if ($.ifExists('.variations_form')) {
                var html = $("<div />").append($('.variations_form').clone()).html();
            } else {
                var html = $("<div />").append($('form.cart:not(.variations_form)').clone()).html();
            }

            aa.find('.product-sticky-cta').append(html);
        });

        $('.product-type-variable .single_variation_wrap').on('show_variation', function (event, variation) {
            var price = $('.product-type-variable .variations_form .woocommerce-Price-amount').html();
            var selval = $('.variations_form select').val();
            $('#product-sticky-header .woocommerce-Price-amount').html(price);
            $('#product-sticky-header select').val(selval);
        });

        $('#product-sticky-header select').on('change', function (event) {
            var selval = $(this).val();
            $('.product-type-variable .variations_form select').val(selval).trigger('change');
        });
    }

    /**
     * Show search form
     */
    const $form = $('#header .search-form');
    const $body = $('body');
    $('a[href="#toggle-search"]').on('click', function (event) {
        event.preventDefault();

        $form.toggleClass('open');
        if ($form.hasClass('open')) {
            $form.find('input').focus(); // focus on search field

            $body.addClass('no-scroll');

            // close search form when clicking outside it
            $form.one('blur', '.search-field', function () {
                $form.removeClass('open');
                $body.removeClass('no-scroll');
            });
        }
    });

    $('.sample-form').on('change', function (event) {
        var selVar = $('.sample-form-radio:checked').val();
        if (selVar) {
            $('.modal-body .gfield_radio li:nth-of-type(' + selVar + ') input').prop('checked', true);
        }
    });
    $('.sample-form').change();

    $('#size_guide').click(function (e) {
        e.preventDefault();
        $('.size_chart').toggle();
        $(this).children('.icontoggle').toggleClass('angle-up-light angle-down-light');
    });

    var $btns = $('.btn-filter').click(function () {
        if (this.id == 'all') {
            $('#parent > div').fadeIn(450);
        } else {
            var $el = $('.' + this.id).fadeIn(450);
            $('#parent > div').not($el).hide();
        }
        $btns.removeClass('active');
        $(this).addClass('active');
    });

    $('#headerFormControlSelect').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });

    /**
     * iframe responsive
     */
    $('main iframe').addClass('embed-responsive-item').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');

    /**
     * Sliders
     */
    $('.upsells .products, .related .products').slick({
        infinite: true,
        arrows: true,
        prevArrow: "<a href='#' class='arrow prev'><i class='icon angle-left'></i></a>",
        nextArrow: "<a href='#' class='arrow next'><i class='icon angle-right'></i></a>",
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }

            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                }
            }
        ]
    });
    $('.product-slider').slick({
        infinite: true,
        arrows: true,
        prevArrow: "<a href='#' class='arrow prev'><i class='icon angle-left'></i></a>",
        nextArrow: "<a href='#' class='arrow next'><i class='icon angle-right'></i></a>",
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }

            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                }
            }
        ]
    });
    $('.popular-product-slider').slick({
        infinite: true,
        arrows: true,
        prevArrow: "<a href='#' class='arrow prev'><i class='icon angle-left'></i></a>",
        nextArrow: "<a href='#' class='arrow next'><i class='icon angle-right'></i></a>",
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        variableWidth: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false,
                }

            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: false,
                }
            },
            {
                breakpoint: 319.98,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: false,
                }
            }
        ]
    });
    $.ifExists('.partners-wrapper', function () {
        $('.partners-slider').slick({
            arrows: false,
            dots: true,
            customPaging: function (slider, i) {
                return '<a class="event-mobile-item"></a>';
            },
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 991.98,
                    settings: "unslick"
                }
            ]
        });
    });

    $('.popular-product-slider').each(function (index) {
        if ($(this).find('.product').length == 1) {
            $(this).slick('slickSetOption', 'centerMode', true);
        }
    });

    /**
     *
     */
    function handleCouponInput() {
        $.ifExists('#couponForm', ($form) => {
            var $submit = $form.find('.btn');

            $form.on('keypress', (e) => {
                console.log('keypress');

                if (e.which == 13) {
                    $submit.trigger('click');
                }
            });
        });
    }

    handleCouponInput();
    $(document).on('updated_wc_div', handleCouponInput);

    /**
     * Hide blur on image
     */
    $.ifExists('.blurred-block', function () {
        $('.undo-blur').on('click', function (e) {
            e.preventDefault();
            $(this).removeClass('show').prevAll('.blurred-image .cover, .blurred-image .blur-ie').addClass('offblur');
        });
        document.documentElement.setAttribute("data-agent", navigator.userAgent);
    });

    /**
     * search bar open
     */
    $('.open-search').on('click', function () {
        $('.search-form').toggleClass('show');
        $('.search-form input').focus();
    });

    $('#search-mob-wrapper .icon').on("click", function () {
        $('#search-mob-wrapper form').submit();
    });

    $('.nav-link .search').on("click", function () {
        $('#search-mob-wrapper input').focus();
    });

    /** add class to class **/
    $.ifExists('#woocommerce_layered_nav-2', function () {
        $(this).addClass('dragScrolling');
        $('.woocommerce-widget-layered-nav-list').addClass('treatment-list-inline');
    });

    /**
     * Horizontal / drag scrolling
     */
    $.ifExists('.dragScrolling', function (dragScroll) {

        dragScroll.each((i, element) => {
            const $this = $(element);
            const $wrapper = $this.find('.treatment-list-inline');

            let isDown = false;
            let startX;
            let scrollLeft;

            $this.on('mousedown', (e) => {
                isDown = true;
                $wrapper.addClass('active');

                startX = e.pageX - $wrapper.scrollLeft();
                scrollLeft = $wrapper.scrollLeft();
            }).on('mouseleave', () => {
                isDown = false;
                $wrapper.removeClass('active');
            }).on('mouseup', () => {
                isDown = false;
                $wrapper.removeClass('active');
            }).on('mousemove', (e) => {
                if (!isDown) {
                    return;
                }

                e.preventDefault();
                const x = e.pageX - $wrapper.scrollLeft();
                const walk = (x - startX) * 3; //scroll-fast
                $wrapper.scrollLeft(scrollLeft - walk);
            });
        })
    });

    /**
     * Initialise slick slider.
     */
    $.ifExists('.swiper-slider', function (dragScroll) {
        $('.swiper-slider').each(function () {
            $(this).find('ul').slick({
                arrows: false,
                dots: true,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 782,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 6,
                        }
                    }
                ]
            });
        })
    });


    /**
     * Filter ervaring
     */
    $.ifExists('.experiences-page-wrapper', function () {
        var $btns = $('.btn-filter');

        $btns.click(function () {
            if (this.id == 'all') {
                $('#parent > div').fadeIn(450);
            } else {
                var $el = $('.' + this.id).fadeIn(450);
                $('#parent > div').not($el).hide();
            }
            $btns.removeClass('active');
            $(this).addClass('active');
        });
    });

    var x = 3;
    $.ifExists('.cardlist', function () {
        var size_li = $(".cardlist li").size();
        $('.cardlist li:lt(' + x + ')').show();
        $('.showmore').on('click', function (e) {
            e.preventDefault();
            x = x + 5;
            $('.cardlist li').slice(0, x).slideDown();
            if (x >= size_li) {
                $('.showmore').hide();
            }
        });
    });

    /**
     * Add icon pencil and link to checkout
     */
    // $.ifExists('.addresses .title', function () {
    //     $('.addresses .title').append('<a href="#" class="edit-adress icon pencil"></a>');
    // });
    //
    // $.ifExists('.steps .current.last', function () {
    //     $('.steps ul').animate({scrollLeft: $('.steps .current.last').position().left}, 500);
    // });
    //
    // $(document).on('click', '.edit-adress', function () {
    //     $('#wizard-t-0').trigger("click");
    //     e.preventDefault();
    // });
    //
    // var checkValue = $("input[name='payment_method']:checked").parent().find('span').html();
    // $("#wizard").on('onStepChanged', function (event, currentIndex, priorIndex) {
    //
    //     if (priorIndex > 1) {
    //         // iDEAL selected as payment method?
    //         if ('ICEPAY_IDEAL' == document.querySelector('input[name="payment_method"]:checked').value) {
    //             // iDEAL issuer (bank) not selected?
    //             if (1 > document.querySelector('select[name="IDEAL_issuer"]').selectedIndex) {
    //                 // Add error payment method.
    //                 document.querySelector('.payment_box.payment_method_ICEPAY_IDEAL').classList.add('error');
    //                 // Go to payment step.
    //                 document.querySelector('#wizard-t-1').dispatchEvent(new Event('click'));
    //                 return false;
    //             } else {
    //                 // Remove error payment method.
    //                 document.querySelector('.payment_box.payment_method_ICEPAY_IDEAL').classList.remove('error');
    //             }
    //         }
    //     }
    //
    //     checkValue = $("input[name='payment_method']:checked").parent().find('span').html();
    //     $('.shipping-address').remove('.paymentinfo').append('<div class="paymentinfo"><header class="title"><h3>' + translationStrings[4] + '</h3><a href="#" class="edit-payment icon pencil"></a></header><div class="paymentlogo">' + checkValue + '</div></div>');
    //
    //     $('.edit-payment').on('click', function (e) {
    //         e.preventDefault();
    //         $('#wizard-t-1').trigger("click");
    //     });
    //
    //     $('#billing_address_2').val(' ' + $('#billing_houseno').val());
    //     if (jQuery("#ship-to-different-address-checkbox").is(":checked")) {
    //         $('#shipping_address_2').val(' ' + $('#shipping_houseno').val());
    //     }
    //
    //     if (jQuery(".order-review-tab").hasClass("current") && $('#billing_address_1').length) {
    //         $(".order-review-tab .billing-address").children().eq(1);
    //         if ($('#billing_company').val().length) {
    //             $('.addresses .billing-address').prepend($('#billing_company').val() + '<br>');
    //         }
    //         if ($('#shipping_company').val().length) {
    //             $('.addresses .shipping-address').prepend($('#shipping_company').val() + '<br>');
    //         } else if ($('#billing_company').val().length) {
    //             $('.addresses .shipping-address').prepend($('#billing_company').val() + '<br>');
    //         }
    //     }
    //
    //     var customer_email = $('.customer_details .customer-email').html();
    //     if (customer_email) {
    //         $('.customer_details th').remove();
    //         $('.customer_details').appendTo('.billing-address');
    //     }
    // });

    $(document).on('click', '.actions li a', function (e) {
        $("html, body").animate({scrollTop: 0}, "slow");
        e.preventDefault();
    });

    if ($(window).width() < 992) {
        $(document).on('click', '.actions.clearfix li a', function (e) {
            e.preventDefault();
            var childPos = $child.offset();
            var parentPos = $parent.offset();
            var childOffset = {
                top: childPos.top - parentPos.top,
                left: childPos.left - parentPos.left
            }

            $parent.animate({
                scrollLeft: childOffset.left + $parent.scrollLeft()
            }, 500);
        });
    }

    if ($(window).width() < 1080) {
        $('.dropdown-hover').after('<div class="dropdown-mobile"></div>');

        $('.dropdown-mobile').on('click', function (e) {
            e.preventDefault();
            const $target = $(e.target);
            const $parent = $target.parent('.dropdown');
            const $sibling = $parent.find(' > .dropdown-menu');

            $target.add($parent).add($sibling).toggleClass('show');
        });

        $('.navbar .dropdown a').click(function (e) {
            e.preventDefault();
            location.href = $(this).attr('href');
        });

        //handle custom dropdown trigger for language selector in mobile navigation
        const $dropdownTrigger = document.querySelector('.trigger-language-selector-dropdown')
        if ($dropdownTrigger) {
            const $dropdownElement = $dropdownTrigger.querySelector('.dropdown-menu')
            const $dropdownArrow = $dropdownTrigger.querySelector('.dropdown-item-icon')
            if ($dropdownElement && $dropdownArrow) {
                $dropdownTrigger.addEventListener('click', (event) => {
                    if (event) event.preventDefault()

                    //bail if it's a child of the list item which is clicked
                    if (event.target.classList.contains('dropdown-item')) return false

                    if ($dropdownElement.classList.contains('show')) {
                        $dropdownElement.classList.remove('show')
                        $dropdownArrow.classList.remove('show')
                    } else {
                        $dropdownElement.classList.add('show')
                        $dropdownArrow.classList.add('show')
                    }
                })
            }
        }
    } else {
        $('.navbar .dropdown').click(function () {
            location.href = $(this).find('a').attr('href');
        });
    }

    /**
     *  check input
     */
    $('.wc_payment_method').each((i, element) => {
        const $element = $(element);
        const $wrapper = $element.find('.wc_payment_block');

        $wrapper.find('input:radio').on('change', (e) => {
            $wrapper.toggleClass('checked', $(e.target).is(':checked'));
        });
    });

    /**
     * Small cart
     */
    $.ifExists('.smallCart-wrapper', function () {
        $('.smallCart-wrapper').prepend('<a class="smallCart-toggle" href="#"></a>');
        $('.smallCart-toggle').on('click', function (e) {
            e.preventDefault();
            $('body').toggleClass('noScroll');
            $('main').toggleClass('shadow');
            $('.smallCart-wrapper').toggleClass('show');
        });
    });

    /**
     *  Tooltip
     */
    $('body').on('mouseenter', '.priceprefixicon', function (e) {
        $(e.currentTarget).addClass('hover');
    }).on('mouseleave', '.priceprefixicon', function (e) {
        $(e.currentTarget).removeClass('hover');
    });

    /** Wrap div around **/
    $('.flex-viewport').wrap('<div class="row"><div class="col-lg-7 ml-auto"></div></div>');
    $('.woocommerce-product-info').wrap('<div class="row no-gutters"><div class="product__info--block"></div></div>');
    $('.wpsl-gmap-canvas').wrap('<div class="google-maps-wrapper"></div>');
    $('.woocommerce-MyAccount-content .woocommerce-orders-table').wrap('<div class="table-responsive"></div>');
    $('.woocommerce-checkout .woocommerce-form-login').wrap('<div class="woocommerce-container-login"></div>');
    $('.woocommerce-checkout .woocommerce-form-login input.input-text').wrap('<span class="woocommerce-input-wrapper"></span>');

    /** Wrap in div **/
    $('#store_locator').wrapInner('<div class="row"></div>');
    $('.woocommerce-MyAccount-content .woocommerce-Addresses .woocommerce-Address').wrapInner('<div class="address-block"></div>');

    /** Append div **/
    $('.legend-wrapper').appendTo('.google-maps-wrapper');

    /** AppendTo div **/
    // $('#payment-list').appendTo('.cart-collaterals');

    /** Prepend div **/
    //$('#wpsl-wrap').prepend('<h2 class="h2">' + translationStrings[2] + '</h2>'); // >Verkooppunten in Nederland

    /** Replace placeholder **/
        //$('#wpsl-search-input').attr('placeholder', translationStrings[3]); // Jouw locatie...

    var data = {
            'action': 'cart_count_retriever'
        };

    jQuery.post(ajax_object.ajax_url, data, function (response) {
        if (response > 0) {
            $('#mini-cart-count').html('<span>' + response + '</span>');
        }
    });

    /**
     * Match height
     */
    $.ifExists('.woocommerce-LoopProduct-link', function () {
        $(this).matchHeight({property: 'min-height'});
        $('.woocommerce-loop-product__title').matchHeight({property: 'min-height'});
    });
    //$('li.product .woocommerce-LoopProduct-link.woocommerce-loop-product__link img').matchHeight({property: 'min-height'});
    //$('.post.preview').matchHeight({proprty: 'min-height'});
    $('.cases-studies-wrapper .cases').matchHeight({proprty: 'min-height'});
    $('.popular-product-slider .slick-slide').matchHeight({proprty: 'min-height'});
    $('.faq-button').matchHeight({property: 'min-height', byRow: false});

    $('.bgFromSrcSet').each((i, element) => {
        const $element = $(element);
        const $images = $element.find('> .srcSetMobile, > .srcSet');

        // Handle lazyload images
        $images
            .filter('.lazyload')
            .on('lazybeforeunveil', (e) => {
                $(e.target).css({
                    'width': '1px',
                    'height': '1px',
                    'z-index': '-1'
                });
            })
            .on('lazyloaded', (e) => {
                setBgSource();
            });

        // Handle images that shouldn't be lazyloaded or are being lazy loaded
        $images.filter(':not(.lazyload)').addClass('d-none');
    });

    $(window).on('resize', function () {
        setBgSource();
    }).trigger('resize');

    $(".product-type-simple").find('.amount').addClass('remove-from-price');

    /**
     * Lazy load background images
     */
    function loadBgImage(element) {
        if (element.tagName === 'IMG') {
            return
        }

        const $element = $(element);
        const image = $element.data('bg-src');

        if (image) {
            $element.css({backgroundImage: 'url(' + image + ')'});
        }
    }

    // Load image on lazy load event
    $(document).on('lazybeforeunveil', function (e) {
        loadBgImage(e.target);
    });

    // Check previously loaded images
    $('.lazyloaded[data-bg-src]').each(function (i, element) {
        loadBgImage(element);
    });

    // Reorder elements on single product page for mobile
    var size_chart = $('.site-main .size-chart');
    var size_clone = $(size_chart).clone();

    $(size_chart).addClass('d-none d-sm-block');

    setTimeout(
        function () {
            if ($.ifExists('.site-main .woocommerce-variation-description')) {
                $(size_clone).addClass('d-block d-sm-none').appendTo('.site-main .woocommerce-variation-description');
            } else {
                $(size_clone).addClass('d-block d-sm-none').insertBefore('.summary.entry-summary .price');
            }
        }, 500);

    $('.container').each(function () {
        var highestBox = 0;

        $(this).find('.faq-block').each(function () {
            if ($(this).height() > highestBox) {
                highestBox = $(this).height();
            }
        })

        $(this).find('.faq-block').css('min-height', highestBox);
    });
});

function setBgSource() {
    /**
     * Set background images according to screen size
     */
    const $window = $(window);
    var $srcSets = $window.width() < 700 && $.ifExists('.srcSetMobile')
        ? $('.srcSetMobile') : $('.srcSet');

    $srcSets.each(function () {
        var $image = $(this);

        var src = $image.prop('currentSrc') || $image.prop('src');

        $image.closest('.bgFromSrcSet')
            .css('background-image', "url('" + src + "')").animate({
            opacity: 1
        }, {
            duration: 1000
        });
    });
}

function initializeFloatingLabels() {
    /**
     * Float labels
     */
    $.ifExists('.form-control', function ($inputs) {
        $inputs.each(function (i, element) {
            const $element = $(element);
            const $wrapper = $element.parents('.form-row').first();

            $element.removeAttr('placeholder');

            $wrapper.floatingFormLabels({
                label: 'label',
                formElements: '.form-control'
            });
        });
    });
}

function websiteLanguage() {
    var theLanguage = $('html').attr('lang');
    return theLanguage;
}

//hide / show donation banner based on step index in checkout
// (function () {
//     $("#wizard").on('onStepChanged', function (event, currentIndex, priorIndex) {
//         var $donationBannerElement = document.querySelector('.donation-banner')
//         if ($donationBannerElement) {
//             if (priorIndex === 2) {
//                 $donationBannerElement.classList.add('donation-banner--visible')
//             } else {
//                 $donationBannerElement.classList.remove('donation-banner--visible')
//             }
//         }
//     })
// })();

//handle global form popup JS
(function () {
    const $triggerElement = document.querySelector('.gfp-trigger')
    const $popupElement = document.querySelector('.gfp-popup')
    const $backgroundElement = document.querySelector('.gfp-popup__background')
    if ($triggerElement && $popupElement && $backgroundElement) new GlobalFormPopup($triggerElement, $popupElement, $backgroundElement)
})();

//init shuffle grid / filters for review archive
(function () {
    const $shuffleContainer = document.querySelector('.experiences-card-columns')

    if ($shuffleContainer) {

        //init shuffle
        const shuffleInstance = new Shuffle($shuffleContainer, {
            itemSelector: '.card-column',
            group: Shuffle.ALL_ITEMS
        })

        //get array of filter link elements
        const $filterLinks = Array.from(document.querySelectorAll('.experiences-filters [data-filter-term]'))

        /**
         * Handle
         * @param event
         */
        const handleFilterButtonClick = (event) => {
            if (event) event.preventDefault()
            const newFilter = event.currentTarget.dataset.filterTerm
            if (newFilter) {

                //make all active buttons inactive
                Array.from(document.querySelectorAll('.experiences-filters [data-filter-term].active')).forEach(($activeFilterItem) => $activeFilterItem.classList.remove('active'))

                //set new active button to active
                event.currentTarget.classList.add('active')

                //filter the grid
                shuffleInstance.filter(newFilter)
            }
        }

        //bind click events to filter links
        if ($filterLinks && $filterLinks.length > 0) $filterLinks.forEach($filterLink => $filterLink.addEventListener("click", handleFilterButtonClick))
    }
})();

//handle vimeo embed
(() => {
    const $triggerElements = Array.from(document.querySelectorAll('[data-vimeo-embed-id]'))
    if ($triggerElements && $triggerElements.length > 0) $triggerElements.forEach($triggerElement => new VimeoEmbed($triggerElement))
})();

//handle video modal
(() => {
    const $triggerElements = Array.from(document.querySelectorAll('[data-video-identifier][data-video-display="popup"]'))
    if ($triggerElements.length > 0) $triggerElements.forEach($triggerElement => new VideoModal($triggerElement))
})();

//handle image modal
(() => {
    const $triggerElements = Array.from(document.querySelectorAll('[data-image-modal-url]'))
    if ($triggerElements.length > 0) $triggerElements.forEach($triggerElement => new ImageModal($triggerElement))
})();

//handle quantity inputs
(() => {
    const handleQuantityInputs = () => {
        Array.from(document.querySelectorAll(".woocommerce-cart .quantity")).forEach(($quantityEl) => {
            const $inputEl = $quantityEl.querySelector("input[type=number]")
            const $plusEl = $quantityEl.querySelector(".quantity-plus")
            const $minEl = $quantityEl.querySelector(".quantity-minus")
            if ($inputEl && $plusEl && $minEl) new QuantityInput($inputEl, $plusEl, $minEl)
        })
    }

    if (document.querySelector(".woocommerce-cart .quantity")) {
        handleQuantityInputs()
        jQuery(document.body).on('wc_fragments_refreshed updated_wc_div', handleQuantityInputs)
    }
})();

(() => {
    const initMaterialInputs = () => {
        const selectors = [
            ...Array.from(document.querySelectorAll('.gfield.material-input')),
            ...Array.from(document.querySelectorAll('.gf-email-verify .ginput_container_email > span'))
        ]
        if (selectors.length > 0) {
            selectors.forEach(($containerElement) => {
                const isTextarea = $containerElement.classList.contains('type-textarea') || $containerElement.classList.contains('type-post_content')
                const $labelElement = $containerElement.querySelector(`label:not(.screen-reader-text)`)
                const $inputElement = $containerElement.querySelector(`${isTextarea ? `textarea` : `input`}`)
                if ($labelElement && $inputElement) new MaterialInput($containerElement, $labelElement, $inputElement)
            })
        }
    }

    initMaterialInputs()
    jQuery(document).on('gform_post_render', initMaterialInputs)
})();

(() => {
    const $mainSlider = $('.single-product-gallery .snippet-product-gallery-slider--main');
    const $navigationSlider = $('.single-product-gallery .snippet-product-gallery-slider--navigation');

    const $mainSliderModal = $('.component-global-popup .snippet-product-gallery-slider--main');
    const $navigationSliderModal = $(`.component-global-popup .snippet-product-gallery-slider--navigation`);

    if ($mainSlider.length > 0) {
        new ProductImageGallery($mainSlider)
    }
    if ($mainSliderModal.length > 0 && $navigationSliderModal.length > 0) {
        new ProductImageGallery($mainSliderModal, $navigationSliderModal)
    }

})();

(() => {
    const popUpIds = []
    const $popUpTargetElements = Array.from(document.querySelectorAll('[data-pop-up-target-id]'))
    if ($popUpTargetElements && $popUpTargetElements.length > 0) {

        //create an array of unique pop-up IDs
        $popUpTargetElements.forEach($targetElement => {
            const popUpId = $targetElement?.dataset?.popUpTargetId ? $targetElement.dataset.popUpTargetId : ''
            if (popUpId && !popUpIds.includes(popUpId)) popUpIds.push(popUpId)
        })

        //handle each pop-up with a PopUp class instance
        if (popUpIds && popUpIds.length > 0) {
                popUpIds.forEach(popUpId => new PopUp(popUpId))
        }
    }
})();

//handle mobile blog filter select change
(() => {
    const $filterDropdown = document.getElementById('category-select-dropdown')
    if ($filterDropdown) {
        $filterDropdown.addEventListener('change', () => {
            let currentUrl = window.location.href
            let newUrl = $filterDropdown.value
            if (currentUrl !== newUrl) window.location.href = `${newUrl}`
        })
    }
})();

//handle population of bap referer field
(() => {
    const referer = document.referrer
    const $refererFields = Array.from(document.querySelectorAll('input.bap-referer-field'))
    if (referer && $refererFields && $refererFields.length > 0) {
        $refererFields.forEach($refererField => $refererField.value = referer)
    }
})();

jQuery(document).ready(function ($) {
    // ---------- Variabele Producten Logica ----------
    if ($('form.variations_form').length) {
        var $form = $('form.variations_form');
        var $startingPrice = $('.starting-price');

        $form.on('show_variation', function () {
            $startingPrice.hide();
        }).on('reset_data hide_variation', function () {
            $('.woocommerce-variation-price').hide();
            $startingPrice.show();
        });

        if ($('.variation_id').val() === '' || $('.variation_id').val() === '0') {
            $('.woocommerce-variation-price').not('.starting-price').hide();
            $startingPrice.show();
        }
    }

    // ---------- Composite Producten Logica ----------
    var $compositeStartingPrice = $('.starting-price-composite');
    var $compositePriceContainer = $('.composite_price');

    function toggleCompositePrices() {
        var hasSelection = false;

        $('.composite_component').each(function () {
            var $component = $(this);
            var $selected = $component.find('select').val();
            if ($selected && $selected !== '') {
                hasSelection = true;
                return false;
            }
        });

        if (hasSelection) {
            $compositeStartingPrice.hide();
            $compositePriceContainer.show();
        } else {
            $compositeStartingPrice.show();
            $compositePriceContainer.hide();
        }
    }

    if ($compositePriceContainer.length || $compositeStartingPrice.length) {
        setTimeout(function () {
            toggleCompositePrices();
        }, 500);

        $(document).on('wc-composite-updated', function () {
            toggleCompositePrices();
        });

        $(document).on('change', '.composite_component select', function () {
            toggleCompositePrices();
        });
    }
});